import { z } from 'zod';

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const MONEY_RESPONSE_REGEX = /^\d+\.\d{2}$/;
/**
 * A negative `cobro_excepcion.monto` is a legitimate surcharge, so the
 * adjustment sum is the one money field allowed to carry a sign. The invoice
 * value, the applied amount and the remainder stay unsigned.
 */
const ADJUSTMENT_RESPONSE_REGEX = /^-?\d+\.\d{2}$/;

const dateOnlySchema = z.string().regex(DATE_ONLY_REGEX, 'date must use YYYY-MM-DD');
const responseMoneySchema = z
  .string()
  .regex(MONEY_RESPONSE_REGEX, 'money values must use 2 decimals');
const adjustmentMoneySchema = z
  .string()
  .regex(ADJUSTMENT_RESPONSE_REGEX, 'adjustment values must use 2 decimals with an optional sign');

export const PREPAID_PREVIEW_POLICY = {
  CURRENT_PERIOD_INVOICE_ONLY: 'CURRENT_PERIOD_INVOICE_ONLY',
} as const;

export type PrepaidPreviewPolicy =
  (typeof PREPAID_PREVIEW_POLICY)[keyof typeof PREPAID_PREVIEW_POLICY];

export const PagoPrepagoPreviewRequestSchema = z.object({
  idCliente: z.coerce.number().int().positive(),
  mesesAdelantado: z.coerce.number().int().min(1).max(12),
  fechaBase: dateOnlySchema.optional(),
});

export type PagoPrepagoPreviewRequest = z.infer<typeof PagoPrepagoPreviewRequestSchema>;

export const PagoPrepagoCurrentInvoiceSchema = z.object({
  id: z.number().int().positive(),
  fechaInicio: dateOnlySchema,
  fechaFin: dateOnlySchema,
  valor: responseMoneySchema,
  ajustesAplicados: adjustmentMoneySchema,
  montoAplicado: responseMoneySchema,
  saldoPendiente: responseMoneySchema,
});

export type PagoPrepagoCurrentInvoice = z.infer<typeof PagoPrepagoCurrentInvoiceSchema>;

export const PagoPrepagoPreviewResponseSchema = z.object({
  idCliente: z.number().int().positive(),
  mesesAdelantado: z.number().int().min(1).max(12),
  primerPeriodoInicio: dateOnlySchema,
  primerPeriodoFin: dateOnlySchema,
  facturaActual: PagoPrepagoCurrentInvoiceSchema.nullable(),
  politica: z.literal(PREPAID_PREVIEW_POLICY.CURRENT_PERIOD_INVOICE_ONLY),
});

export type PagoPrepagoPreviewResponse = z.infer<typeof PagoPrepagoPreviewResponseSchema>;
